import { FlagIcon } from '@heroicons/react/24/outline';

export function RomAllRequestsEmptyState() {
  return (
    <div className="flex justify-center px-[24px] py-12">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-200">
          <FlagIcon className="mx-auto h-6 w-auto text-gray-700" />
        </div>
        <p className="text-gray-400">There are no trip requests to show</p>
      </div>
    </div>
  );
}
